module.exports = __webpack_public_path__ + "img/procesiune_1kl.23bfbd53.jpg";